import { ClimaproData, ClubvwData } from './portal';
import { Vehicle } from './vehicles';

export interface PersonBenefits {
	identitykitId: string;
	climapro: ClimaproData;
	clubVW: ClubvwData;
	benefits: {
		discounts: Discount[];
		promotions?: Promotion[];
		vwDataVouchers: VWDataVouchers[];
		salesforceVouchers: SalesforceVouchers[];
	};
}

export interface Discount {
	id: string;
	value: string;
	startDate?: Date | string;
	endDate?: Date | string;
}
export interface Promotion {
	name: string;
	status: PromotionStatus;
	contestant?: {
		status: string;
		data: any;
	} | null;
}

export enum PromotionStatus {
	PRE = 'PRE',
	OPEN = 'OPEN',
	CLOSED = 'CLOSED',
}

export type VWDataVoucherDestination = 'ForYou' | 'ForCars';

export interface VWDataVouchers {
	id: string;
	vin?: string;
	priority: number;
	type: string;
	validityDate: number | Date | string;
	expirationDate?: number | Date | null | string;
	destination: VWDataVoucherDestination;
	card: {
		title: string;
		imageUrl: string;
		cta: Cta;
	};
	layer: {
		title: string;
		imageUrl: string;
		description: string;
		modoEmpleo: string;
		legal: string;
		cta: Cta;
	};
	status: VoucherStatus;
}

export interface SalesforceVouchers {
	id: string;
	name: string;
	vgedCampaign: VouchersCampaign; //Antes campaing
	vgedAmount?: number; // Antes amount
	vgedMKTVoucherImage1: string; // Antes imageUrl
	vgedMKTVoucherImage2: string; // Antes imageVerticalUrl
	vgedVoucherType?: string; // Antes type
	priority: number; // Antes prioridad
	status: VoucherStatus; //Antes BonusStatus
	pklVoucherStatusC: string;
	vgedActivationDate: number | Date | string; // Antes dateValidity
	vgedExpirationDate?: number | Date | null | string; // Antes dateExpiration
	vgedRedeemedDate?: number | Date | null | string; // Antes enjoyedDate
	vgedMKTVoucherTitle: string; // Antes title
	vgedVoucherDescription: string; // Antes description
	vgedMKTVoucherText: string; // Antes modoEmpleo
	vgedMKTVoucherDisclaimer: string; // Antes legalText
	vgedVin?: string; // Antes frame
	vgedRegistrationPlate?: string;
	vgedFullName: string;
	vgedCreationDate: number | Date | string;
	vgedEmail?: string;
	vgedValue?: string;
	vgedActivationExpirationDate?: number | Date | null | string;
	vgedRedemptionExpirationDate?: number | Date | null | string;
	vgedMKTIIsPublished?: boolean;
	vgedMKTURLLink?: string; // Antes cta -> src
	vgedMKTURLLabel?: string; // Antes cta -> label
}

export enum VouchersCampaign {
	'ENTREGA_IDEAL' = '701QF00000oUwrSYAS',
	'OneToOne_Polo' = '701QF00000yUhK9YAK',
	'OneToOne_ID' = '701QF00000xc39NYAQ',
	'OneToOne_ID_Flotas' = '701Tr00000x9YdBIAU',
	'IDWeChargePostPedido' = '701QF00001RQU42YAH',
}

export enum FeatureAppStepCitaMode {
	'VENTA' = 'featureAppCitaVentaId',
	'POSVENTA' = 'featureAppCitaPosventaId',
}

export enum VoucherStatus {
	'EXPIRED' = 'EXPIRED',
	'ENJOYED' = 'ENJOYED',
	'TO_ENJOY' = 'TO_ENJOY',
	'TO_ENJOY_SOON' = 'TO_ENJOY_SOON',
	'NO_EXPIRATION' = 'NO_EXPIRATION',
}

export enum VoucherTypeEnum {
	'PERSON' = 'PERSON',
	'CAR' = 'CAR',
	'ENJOYED' = 'ENJOYED',
}

export interface CarVoucher extends Vehicle {
	personVehicleRelation?: boolean;
	salesGroup: string;
	type: string;
}

export interface Cta {
	src?: string; //Antes bonusPageId
	label?: string; // Antes text
}
